<template lang="pug">
transition( :name='`ghost-${pos}`' appear )
  .sidebar.col-11.col-lg-4(
    v-show='currentSidebar && available && side === pos'
    :class='pos'
  )
    slot( name='close-button' )
      w-btn-close( @click.prevent='closeSidebar' )
    slot
      .sidebar-container( :key='name' )
        .sidebar-scroller( v-bar )
          .sidebar-inner
            component( :is='name' v-bind='sidebarData' )
</template>

<script lang="js">
import { mapActions, mapState } from 'vuex'
import { sidebars, components as sidebarComponents } from '@/sidebars'
import WBtnClose from '@/widgets/w-btn-close'

export default {
  name: 'sidebar',
  mixins: [],
  components: { ...sidebarComponents, WBtnClose },
  props: {
    pos: {
      type: String,
      default: 'right'
    },
  },
  data() {
    return {
      sidebars
    }
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions([ 'closeSidebar' ]),
  },
  computed: {
    ...mapState([ 'currentSidebar' ]),
    name() {
      return ( this.currentSidebar && this.currentSidebar.name ) || ''
    },
    sidebarData() {
      return ( this.currentSidebar && this.currentSidebar.data ) || {}
    },
    side() {
      return this.sidebars[ this.name ] && this.sidebars[ this.name ].pos
    },
    available() {
      return this.sidebars[ this.name ] && this.sidebars[ this.name ].meta.available
    },
  }
}
</script>

<style lang="scss">
.sidebar {
  position: fixed;
  top: 0;
  bottom: 0;
  z-index: 10;
  box-sizing: border-box;
  padding: 0;
  /* transform: translateX(0); */
  /* opacity: 1; */
  /* transition: all 400ms ease-in-out; */
  .sidebar-container  {
    position: relative;
    height: 100vh;
    background: var(--c-bg);
    padding: var(--s-lg) 0;
  }
  &.left {
    left: 0;
    .w-btn-close {
      right: calc( var(--s-xl) * -1 + var(--pad-close-button) - 4px);
    }
    .sidebar-container {
      right: var(--s-xl);
      box-shadow: 0 0px 128px -32px var(--c-glow), 4px 0 14px -8px #8df;
      padding-left: var(--s-xl);
    }
  }
  &.right {
    right: 0;
    .w-btn-close {
      left: calc( var(--s-xl) * -1 + var(--pad-close-button) - 4px);
      right: unset;
    }
    .sidebar-container {
      left: var(--s-xl);
      box-shadow: 0 0px 128px -32px var(--c-glow), -4px 0 14px -8px #8df;
      padding-right: var(--s-xl);
    }
  }
}
</style>
